import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { State } from 'src/app/reducers';
import { Assessment } from 'src/app/store/assessment/assessment.models';
import {createUserAssessment, loadAssessments} from '../../../store/assessment/assessment.actions';
import { User } from 'src/app/store/auth/auth.models';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { filter } from 'rxjs/internal/operators/filter';



@Component({
  selector: 'app-assesment-list',
  templateUrl: './assesment-list.component.html',
  styleUrls: ['./assesment-list.component.scss']
})
export class AssesmentListComponent implements OnInit {
  private destroyer$: Subject<any> = new Subject();

  assessments: any;
  currentUser: User;

  // Attachement to the store
  loadingAssessments$: Observable<boolean>;
  loadingAssessmentsError$: Observable<string>;
  allAssessments$: Observable<Assessment[]>;

  startingAssessment$: Observable<boolean>;
  startingAssessmentError$: Observable<string>;
  currentUserAssessment$: Observable<Assessment>;



  constructor(private store: Store<State>,
    private router: Router,
     private activatedRoute: ActivatedRoute) {
      this.allAssessments$ = store.select((state) => state.assessments.allAssessments);
      this.loadingAssessments$ = store.select((state) => state.assessments.loadingAssessment);
      this.startingAssessment$ = store.select((state) => state.assessments.creatingUserAssessment);
      this.loadingAssessmentsError$ = store.select((state) => state.assessments.loadingAssessmentError);

    this.allAssessments$ = store.select((state) => state.assessments.allAssessments);
    this.store.dispatch(loadAssessments({ categoryId: null }));

    store.select(state => state.assessments.currentUserAssessment).pipe(takeUntil(this.destroyer$), filter(d => !!d)).subscribe(
      v => this.router.navigate(['/assessments', v.id, 'welcome']));
    store.select(state => state.auth.authenticatedUser).pipe(takeUntil(this.destroyer$)).subscribe(user => this.currentUser = user);
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(val =>
      {
        console.log(val)
        this.allAssessments$.subscribe(values =>{
            for (let key in values) {
              if(key === val.id.match(/[A-Z][a-z]+|[0-9]+/g).join(" ") || key.startsWith(val.id.match(/[A-Z][a-z]+|[0-9]+/g).join(" "))) {
                console.log('key', key)

                this.assessments = (values[key])
              }
            }
        })
      })
  }

  startAssessment(assessment: Assessment) {
    this.store.dispatch(createUserAssessment({userId: this.currentUser.sub, assessmentId: assessment.assessment_id, categoryId: assessment.assessmentCatID}));
  }

  ngOnDestroy(): void {
    this.destroyer$.next(false);
    this.destroyer$.complete();
  }

}
